
// Robust polyfill for Safari and other browsers
// Use globalThis as the standard global object
const globalObject = 
  typeof globalThis !== 'undefined' ? globalThis :
  typeof window !== 'undefined' ? window :
  typeof self !== 'undefined' ? self : {};

// Polyfill global
if ((globalObject as any).global === undefined) {
  (globalObject as any).global = globalObject;
}

// Polyfill process
if ((globalObject as any).process === undefined) {
  (globalObject as any).process = { 
    env: {},
    browser: true,
    version: ''
  };
} else if (!(globalObject as any).process.env) {
  (globalObject as any).process.env = {};
}

export {};
